module.exports = __webpack_public_path__ + "img/google-play-review.9e6c2d2a.png";